import { getItemFromSessionStorage, addItemToSessionStorage, addItemToLocalStorage, getItemFromLocalStorage } from '@/assets/scripts/windowStorage'
import { USER_SESSION } from '@/assets/constants/core'
import { moduleMapper } from '@/store/helpers/modules.map'

export const PRE_LOAD_STORE_DATA = (state) => {
	const sessionInfo = getItemFromSessionStorage(USER_SESSION)
	const rememberMeEntityInfo = JSON.parse(window.localStorage.getItem(`bai-remember-me-entity-info-${state.appThemeClientType}`))
	const baiV4SavedTheme = getItemFromLocalStorage(`bai-v4-theme-mode-${state.appThemeClientType}`)
    state[moduleMapper.SESSION].currentAppThemeClientType = state.appThemeClientType

	if (rememberMeEntityInfo) {
		state[moduleMapper.SESSION].rememberMeEntityInfo = rememberMeEntityInfo
	}

	if (baiV4SavedTheme) {
		state.themeMode = baiV4SavedTheme.theme
		state.themeModeId = baiV4SavedTheme.themeModeId
	}

	if (sessionInfo) {
		state[moduleMapper.SESSION].allUserInfo = sessionInfo
		state[moduleMapper.SESSION].userSession = sessionInfo.session

		/* Calc of session remaining time on refresh */
		const remainingSeconds = sessionInfo.session.remainingSecondsForSessionExpire
		const currentTime = new Date().getTime()
		const expiryDate = new Date()

		expiryDate.setTime(currentTime + remainingSeconds * 1000)
		state[moduleMapper.SESSION].localExpiryDate = expiryDate.getTime()
		state[moduleMapper.SESSION].localExpirySpan = ((state[moduleMapper.SESSION].localExpiryDate - currentTime) / 1000)
	}
}

export const SAVE_ROUTE_FOR_DIRECT_AFTER_REFRESH = (state, payload) => {
	addItemToSessionStorage('bai-v4-aux-redirect-link-after-refresh', payload)
}

export const UPDATE_DEVICE_IN_USE = (state, payload) => {
	state.deviceInUse = payload
}

export const UPDATE_IS_MOBILE_APP = (state, payload) => {
	state.mobileApp = payload
}

export const UPDATE_SHOW_ALERT_REMEMBER_ME_MODAL = (state, payload) => {
	state.showAlertRememberMeModal = payload
}

export const UPDATE_STATUS_BAR_STYLE = (state, payload) => {
	state.statusBarStyle = payload
}

export const UPDATE_APP_THEME_CLIENT_TYPE = (state, payload) => {
	state.appThemeClientType = payload
    state[moduleMapper.SESSION].currentAppThemeClientType = payload
}

export const UPDATE_APP_THEME_MODE = async (state, payload) => {
	let theme = payload

    try {
        if (payload === 'system') {
            if (window.cordova?.platformId === 'android') {
                await window.cordova.plugins.ThemeDetection.isAvailable()
                await window.cordova.plugins.ThemeDetection.isDarkModeEnabled($event => {
                    theme = $event.value ? 'dark' : 'light'
                })
            } else {
                theme = window.matchMedia('(prefers-color-scheme:dark)').matches ? 'dark' : 'light'
            }
        }
    } catch {
        theme = 'light'
    } finally {
        state.themeMode = theme
        state.statusBarStyle = 'lightContent'
        if (window.StatusBar) window.StatusBar.styleLightContent()
        state.themeModeId = payload
        addItemToLocalStorage(`bai-v4-theme-mode-${state.appThemeClientType}`, { themeModeId: state.themeModeId, theme: state.themeMode })
        if (state.session.allUserInfo) addItemToLocalStorage(`bai-v4-theme-auth-mode-${state.appThemeClientType}`, { themeModeId: state.themeModeId, theme: state.themeMode })
    }
}

export const UPDATE_PREVENT_MOBILE_FEATURE_BACK = (state, payload) => {
	state.preventMobileFeatureBack = payload
}

export const UPDATE_PREVENT_MOBILE_SIDE_MODAL_BACK = (state, payload) => {
	state.preventMobileSideModalBack = payload
}

export const UPDATE_APP_SCROLL_POSITION = (state, payload) => {
	state.appScroll = payload
}

export const UPDATE_SIDE_MODAL_SCROLL_POSITION = (state, payload) => {
	state.sideModalScroll = payload
}

export const UPDATE_FOOTER_SHOW_STATE = (state, payload) => {
	state.footerIsBeingShowed = payload
}

export const UPDATE_KEYBOARD_HEIGHT_STATE = (state, payload) => {
    state.keyboardHeight = payload
}

export const UPDATE_APP_TRANSPARENCY_STATE = (state, payload) => {
	state.applyTransparencyToApp = payload
}

export const ADD_TO_REQUESTS_LIST = (state, payload) => {
	state.requests.push(payload)
}

export const CLEAR_ALL_PENDING_REQUESTS = (state, payload) => {
	state.requests.forEach(element => {
		element.source.cancel()
	})
	state.requests = []
}

/** saves routes params to move from one route to another, since vue-router doesnt allow it now
@payload { object } - route params
*/
export const SAVING_ROUTE_PARAMS = (state, payload) => {
	state.routeParams = payload
}

export const REMOVING_ROUTE_PARAMS = (state, payload) => {
	state.routeParams = null
}

/**************************************************
*												  *
*	               TOKEN Modal Logic           	  *
*												  *
**************************************************/
/** updates display of token challenge modal
@payload { object } - challenge mock for token submit response
*/
export const SHOW_TOKEN_CHALLENGE_MODAL = (state, payload) => {
	state.showTokenChallengeModal = true
	state.tokenChallengeData = payload
}

/** updates display of token challenge modal to false
*/
export const HIDE_TOKEN_CHALLENGE_MODAL = (state, payload) => {
	state.showTokenChallengeModal = false
	state.tokenChallengeData = null
}
